import { useContext } from 'react'
import { EditorContext } from '../EditorProvider'

export function useEditorContext() {
  const context = useContext(EditorContext)
  if (!context) {
    throw new Error('useEditorContext must be used within an EditorProvider')
  }
  return context
}
